(function() {
  // Add .loaded to hero + trust strip (triggers stagger animations)
  function heroLoaded() {
    var hero = document.querySelector('.custom-hero');
    if (hero) hero.classList.add('loaded');
    var trust = document.querySelector('.custom-hero__trust');
    if (trust) trust.classList.add('loaded');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', heroLoaded);
  } else {
    heroLoaded();
  }
  document.addEventListener('shopify:section:load', heroLoaded);

  // IntersectionObserver-based scroll animations
  if (typeof IntersectionObserver === 'undefined') return;

  function init() {
    const obs = new IntersectionObserver(function(entries) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          obs.unobserve(entry.target);
        }
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    function observe() {
      document.querySelectorAll('.dropby-fade, .dropby-pop, .dropby-slide-l, .dropby-slide-r, .dropby-ornament').forEach(function(el) {
        if (!el.classList.contains('in')) obs.observe(el);
      });
    }

    observe();
    document.addEventListener('shopify:section:load', observe);
  }

  // Small delay so initial paint renders elements in their pre-animation state
  // before the observer starts firing. Without this, above-fold elements
  // get .in added before the user sees the transition.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      requestAnimationFrame(function() { requestAnimationFrame(init); });
    });
  } else {
    requestAnimationFrame(function() { requestAnimationFrame(init); });
  }

  // ── Counter animation for stats ──────────────────────────────
  // Counts up from 0 to target when the element scrolls into view.
  // Parses the rendered text to extract prefix, number, suffix, decimals,
  // and comma formatting automatically.
  function initCounters() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    // Parse a stat string like "£2M", "4.9★", "1,657", "397"
    function parseStatText(el) {
      // Get text content only (strips HTML like <span> star)
      var raw = el.textContent.trim();
      // Match optional prefix (non-digit, non-dot, non-comma chars),
      // the number (digits, dots, commas), and optional suffix
      var m = raw.match(/^([^\d]*?)([\d,.]+)(.*)$/);
      if (!m) return null;
      var prefix = m[1];
      var numStr = m[2];
      var suffix = m[3];
      // Check for comma formatting
      var hasComma = numStr.indexOf(',') !== -1;
      var cleanNum = numStr.replace(/,/g, '');
      var target = parseFloat(cleanNum);
      if (isNaN(target)) return null;
      // Decimal places
      var dotIdx = cleanNum.indexOf('.');
      var decimals = dotIdx === -1 ? 0 : cleanNum.length - dotIdx - 1;
      return { prefix: prefix, target: target, suffix: suffix, decimals: decimals, hasComma: hasComma };
    }

    function formatNumber(val, decimals, hasComma) {
      var str = val.toFixed(decimals);
      if (hasComma) {
        var parts = str.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        str = parts.join('.');
      }
      return str;
    }

    // Ease-out cubic: fast start, gentle deceleration
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    // Special two-phase animation for millions (e.g. "£2M")
    // Phase 1: rapid climb through hundreds of thousands → £1M
    // Phase 2: slow dramatic climb £1M → £2M
    function animateMillions(el, data) {
      var starSpan = el.querySelector('.custom-stat__star');
      var starHTML = starSpan ? starSpan.outerHTML : '';
      var suffix = data.suffix;
      if (starSpan) {
        suffix = suffix.replace('★', '').replace(starSpan.textContent, '');
      }

      var targetM = data.target; // e.g. 2
      var climbDuration = 1400; // fast climb 0 → £1M
      var pauseDuration = 800;  // hold on £1M — let it sink in
      var start = null;

      function formatClimbValue(val) {
        if (val >= 900000) return data.prefix + '1M';
        var k = Math.round(val / 100000) * 100000;
        if (k < 100000) k = 100000;
        return data.prefix + Math.round(k / 1000) + 'K';
      }

      function step(ts) {
        if (!start) start = ts;
        var elapsed = ts - start;

        if (elapsed < climbDuration) {
          // Phase 1: rapid climb through £100K → £1M
          var p = Math.min(elapsed / climbDuration, 1);
          var eased = easeOutCubic(p);
          var val = eased * 1000000;
          el.innerHTML = formatClimbValue(val) + starHTML;
          requestAnimationFrame(step);
        } else if (elapsed < climbDuration + pauseDuration) {
          // Phase 2: hold on £1M for dramatic pause
          el.innerHTML = data.prefix + '1M' + starHTML;
          requestAnimationFrame(step);
        } else {
          // Phase 3: snap to final value — £2M
          el.innerHTML = data.prefix + formatNumber(data.target, data.decimals, data.hasComma) + suffix + starHTML;
        }
      }
      requestAnimationFrame(step);
    }

    function animateCounter(el, data) {
      // Detect millions suffix — route to special animation
      if (/M$/i.test(data.suffix) && data.target <= 10) {
        animateMillions(el, data);
        return;
      }

      var duration = 1800; // ms
      var start = null;
      // Preserve any inner HTML (e.g. star span) after the number text
      var starSpan = el.querySelector('.custom-stat__star');
      var starHTML = starSpan ? starSpan.outerHTML : '';
      // Strip star from suffix since we'll append the HTML directly
      var suffix = data.suffix;
      if (starSpan) {
        suffix = suffix.replace('★', '').replace(starSpan.textContent, '');
      }

      function step(ts) {
        if (!start) start = ts;
        var elapsed = ts - start;
        var progress = Math.min(elapsed / duration, 1);
        var eased = easeOutCubic(progress);
        var current = eased * data.target;
        var formatted = data.prefix + formatNumber(current, data.decimals, data.hasComma) + suffix;
        if (starHTML) formatted += starHTML;
        el.innerHTML = formatted;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    var counterObs = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          var el = entries[i].target;
          counterObs.unobserve(el);
          var data = parseStatText(el);
          if (!data) continue;
          if (reducedMotion) continue; // already shows final value
          animateCounter(el, data);
        }
      }
    }, { threshold: 0.3 });

    counters.forEach(function(el) { counterObs.observe(el); });
  }

  // ── Parallax on manifesto background ─────────────────────────
  function initParallax() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    if (reducedMotion || isMobile) return;

    var bg = document.querySelector('.custom-manifesto__bg');
    if (!bg) return;

    // Apply overflow hidden + extended bounds for parallax travel
    bg.style.overflow = 'hidden';
    bg.style.inset = '-15% 0';
    var img = bg.querySelector('img');
    if (img) img.style.willChange = 'transform';

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        ticking = false;
        if (!img) return;
        var rect = bg.getBoundingClientRect();
        var vh = window.innerHeight;
        // Only compute when section is in/near viewport
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        // Normalise: 0 when bottom of section at top of viewport,
        // 1 when top of section at bottom of viewport
        var progress = (vh - rect.top) / (vh + rect.height);
        // Clamp 0–1, map to -30px to +30px
        progress = Math.max(0, Math.min(1, progress));
        var translate = (progress - 0.5) * 60; // -30 to +30
        img.style.transform = 'translate3d(0,' + translate + 'px,0)';
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // initial position
  }

  // Initialise counters and parallax after DOM ready
  function initExtras() {
    initCounters();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExtras);
  } else {
    initExtras();
  }
  document.addEventListener('shopify:section:load', function() {
    initCounters();
    initParallax();
  });
})();
